import React from "react";
import "./Background3d.css";

const Background3d = () => (
  <div className="spline-stage">
    <div className="spline-glow" aria-hidden="true" />
    <iframe
      title="Animated frontend technology logos"
      src="https://my.spline.design/awesomefolio-0c39efc3de701ba97be395cc128e4e2f/"
      loading="lazy"
      frameBorder="0"
      allow="autoplay"
    />
    <div className="spline-cover" aria-hidden="true" />
  </div>
);

export default Background3d;
